/** Calendar-only delivery estimate. Danish dispatch calendar, never visitor-local midnight. */
const DAY = 86400000;
const iso = date => date.toISOString().slice(0, 10);

export function easterSunday(year) {
  const a = year % 19, b = Math.floor(year / 100), c = year % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  return new Date(Date.UTC(year, month - 1, (h + l - 7 * m + 114) % 31 + 1, 12));
}

export function danishHolidays(year) {
  const easter = easterSunday(year);
  // Public holidays, not additional bank-only closing days. Store Bededag is no longer included.
  return new Set([
    `${year}-01-01`, `${year}-12-25`, `${year}-12-26`,
    ...[-3, -2, 1, 39, 50].map(offset => iso(new Date(+easter + offset * DAY)))
  ]);
}

export function deliveryDate(now = new Date(), businessDays = 2, closedDates = []) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(now);
  const get = type => Number(parts.find(part => part.type === type).value);
  const date = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
  const extra = new Set(closedDates);
  const parsed = Number(businessDays);
  let remaining = Number.isFinite(parsed) ? Math.max(1, Math.min(7, Math.trunc(parsed))) : 2;
  let year = date.getUTCFullYear(), holidays = danishHolidays(year);
  // Current day never counts. Incrementing UTC calendar days avoids DST arithmetic errors.
  while (remaining > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (date.getUTCFullYear() !== year) {
      year = date.getUTCFullYear();
      holidays = danishHolidays(year);
    }
    const day = date.getUTCDay(), key = iso(date);
    if (day !== 0 && day !== 6 && !holidays.has(key) && !extra.has(key)) remaining--;
  }
  return date;
}

export function deliveryLabel(date, locale = 'da-DK') {
  let formatter;
  try { formatter = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); }
  catch { formatter = new Intl.DateTimeFormat('da-DK', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); }
  const label = formatter.format(date);
  return label.charAt(0).toLocaleUpperCase() + label.slice(1);
}

// Custom elements upgrade after every cart fragment replacement without coupling to mutation code.
if (globalThis.customElements && !customElements.get('nm-delivery-estimate')) {
  customElements.define('nm-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        clearTimeout(this.timer);
        const closed = (this.dataset.closedDates || '').split(/\s+|,/).filter(value => /^\d{4}-\d{2}-\d{2}$/.test(value));
        const date = deliveryDate(new Date(), this.dataset.days || 2, closed);
        const time = this.querySelector('time');
        if (time) {
          time.dateTime = iso(date);
          time.textContent = deliveryLabel(date, this.dataset.locale || 'da-DK');
        }
        this.timer = setTimeout(this.refresh, 60000);
      };
      this.refresh();
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  });
}
